<template>
    <div class="takequiz">
      <div class="startpage" v-if="startScreen">
      <start-page :lang="startLang" @start-quiz="startQuiz"/>
      </div>
      
       <div class="beginquiz" v-if="!startScreen" >
    <!-- <h2> All Quiz mumbo jumbo goes here</h2>dfdf {{answerView}} -->
    <quiz-title />
    <h4>Points {{pointCount}} </h4>
    <div v-if="!answerView">    
        <question-type :lang="typeLang" @selected-type="selectedType" />
    </div>
    <div v-if="answerView">
    <question :question="currentQuestion" @choose-type="selectView" />
   
    </div>
     </div>
    </div>
</template>
<script>
import Question from './Question'
import QuizTitle from './Title'
import StartPage from './StartQuiz'
// import QuestionChoice from './QuestionChoice'
import QuestionType from './QuestionType'
import db from '../../../lib/db'
// import questions from '../../assets/questions'
export default {
  name: 'TakeQuiz',
   data () {
    return {
       startScreen: true,
       startLang: {},
       typeLang: {},
       answerView: false ,
       pointCount: 0,
       questions: {
         },
      //  twoPoint: questions.q2,
      //  threePoint: questions.q3
      //   threePoint: [
      //     {
      //     id: '3q1',
      //     question: '3 point Question number ONE',
      //     choices:['Some', 'None', 'All', 'Every'],
       
      //     freeThrows: [
      //       {
      //       id: '3q1ft1',
      //       question: 'Free Throw Question 1',
      //       choices:['fr1','ftr2','ftr3','ftr4'],
      //       correctAnswer: 'fr1'

  
      //   },
      //     {
      //      id: '3q1ft2',
      //       question: 'Free Throw Question 2',
      //       choices:['fr1','ftr2','ftr3','ftr4'],
      //       correctAnswer: 'fr1'

      //   },
      //   {
      //    id: '3q1ft3',
      //       question: 'Free Throw Question 3',
      //       choices:['fr1','ftr2','ftr3','ftr4'],
      //       correctAnswer: 'fr1'

      //   }
      //   ],
      //     },
      //   {
      //     id: '3q2',
      //     question: '3 point Question number Two',
      //     choices:['Some', 'None', 'All', 'Every'],
      //     freeThrows: [{
      //       id: '3q2ft1',
      //       question: 'Free Throw Question 1',
      //       choices:['fr1','ftr2','ftr3','ftr4'],
      //       correctAnswer: 'fr1'

  
      //   },
      //     {
      //      id: '3q2ft2',
      //       question: 'Free Throw Question 2',
      //       choices:['fr1','ftr2','ftr3','ftr4'],
      //       correctAnswer: 'fr1'

      //   },
      //   {
      //    id: '3q2ft3',
      //       question: 'Free Throw Question 3',
      //       choices:['fr1','ftr2','ftr3','ftr4'],
      //       correctAnswer: 'fr1'

      //   }],
      //   },
      //   {
      //     id: '3q3',
      //     question: '3 point Question number Three',
      //     choices:['Some', 'None', 'All', 'Every'],
      //     freeThrows: [{
      //       id: '3q3ft1',
      //       question: 'Free Throw Question 1',
      //       choices:['fr1','ftr2','ftr3','ftr4'],
      //       correctAnswer: 'fr1'

  
      //   },
      //     {
      //      id: '3q3ft2',
      //       question: 'Free Throw Question 2',
      //       choices:['fr1','ftr2','ftr3','ftr4'],
      //       correctAnswer: 'fr1'

      //   },
      //   {
      //    id: '3q3ft3',
      //       question: 'Free Throw Question 3',
      //       choices:['fr1','ftr2','ftr3','ftr4'],
      //       correctAnswer: 'fr1'

      //   }],
      //     }
      //  ],
      //  currentQuestion: {
      //    'points': null,
      //    'question': '',
      //    'choices': []
      //  },
      //  currPoint: ''
      //  currentQuestion: {
      //    'points': null,
      //    'question': '',
      //    'choices': []
      //  },
    }
  },
  props: {
    msg: String
  }, 
  mounted(){
    console.log('go mount ')
    this.welcomeQuiz('language/quizStart','startLang').then(()=>{
      console.log('now geimme some questions')
      this.getQuestions();
    })
  },
    methods: {
      // for testing onlu
      getQuestions: function (){
        db.getRef().ref('demo').once('value').then((snapshot) => {
          this.questions = snapshot.val()
          console.log(snapshot.val())
        })
      },
      getLanguage: function (path,lang) {
          return db.getRef().ref(path).once('value').then((snapshot) => {
    console.log('snap ', snapshot.val())
    this[lang] = snapshot.val()
          return snapshot.val()
          })
      },
      welcomeQuiz: function(path,lang){
        return this.getLanguage('language/quizStart','startLang');
    //     db.getRef().ref(path).once('value').then((snapshot) => {
    // console.log('snap ', snapshot.val())
    // this[lang] = snapshot.val()
    // })
      },
      welcomeType: function() {
        this.getLanguage('language/questionType','typeLang')
      },
      startQuiz: function(){
        this.startScreen = false;
        this.welcomeType();
      },
      selectView: function() {
        this.answerView = false;
        console.log('need to choose type')
      },
    selectedAnswer: function(point) {
        this.answerView = false
        this.pointCount +=point 
        console.log('the answwer, ', point)

    },
   
    selectedType: function(point) {
        this.answerView = true;
        console.log('point ', point)
        this.currPoint = point;
        this.currentQuestion = (point === 2) ? this.questions.q2.pop() :
        (point === 3) ? this.questions.q3.pop() : null

        // console.log('do the tpe thing')
    }
    },
  components: {
      Question,
      QuizTitle, 
      // QuestionChoice,
      QuestionType,
      StartPage
  }
}
</script>

<style>

</style>
